import { render, staticRenderFns } from "./PermissionSelectFromAll.vue?vue&type=template&id=06891156&scoped=true&"
import script from "./PermissionSelectFromAll.vue?vue&type=script&lang=js&"
export * from "./PermissionSelectFromAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06891156",
  null
  
)

export default component.exports